import { PositionsAclSidecar, TypedRedactionObject } from './types';

export const aclRedactionFixture: TypedRedactionObject = {
  status: 'redacted',
  reason: 'acl_denied',
};

export const positionsAclSidecarFixture: PositionsAclSidecar = {
  schema_version: 'order_service.positions.acl_sidecar.v1',
  strategy: 'sidecar_preview',
  status: 'applied',
  fail_closed: true,
  partial: true,
  coverage: {
    scope: 'allowed_accounts_only',
    visible_account_count: 1,
    visible_position_count: 1,
    excluded_resources: {
      status: 'present',
      count_disclosed: false,
    },
  },
  redaction_summary: {
    redacted_field_groups: ['average_cost', 'pnl', 'profit'],
    excluded_resources: {
      status: 'present',
      count_disclosed: false,
    },
  },
};

export const positionsAclMaskedValuesFixture = {
  symbol: 'SBACLTEST',
  quantity: 50,
  average_cost: aclRedactionFixture,
  pnl: aclRedactionFixture,
  profit: aclRedactionFixture,
};

export const positionsAclDashboardMetricsFixture = [
  { key: 'total_pnl', label: 'Total P&L', value: aclRedactionFixture },
  { key: 'day_pnl', label: 'Day P&L', value: aclRedactionFixture },
  { key: 'available_margin', label: 'Available Margin', value: null },
  { key: 'used_margin', label: 'Used Margin', value: aclRedactionFixture },
  { key: 'active_positions', label: 'Active Positions', value: 1 },
];
